import {Actions} from "userform/actions";
import {
  ICompanyInfo,
  IDocument,
  ILoanInfo,
  IReference,
  IUserStatus,
  IUTMParams,
} from "StateInterface";
import {flagsState, handleSingleFlagChange, IFlaggedState} from "reducers/flagTools";
import {Flags} from "reducers/flagActions";
import {Actions as DocumentActions} from "documents/actions";
import {Actions as InsuranceActions} from "insurance/actions";
import {getCompletionDetails, getLandingFlag, validateUtmParams, getV3LandingFlag} from "userform/utils";
import {Actions as ConsentActions} from "consent/actions";
import {logBranchEvent, userId, documentType} from "analytics/branch";
import {Actions as ProfileAction} from "profile/actions";

export interface IState extends IFlaggedState<Flags> {
  userStatus: IUserStatus;
  loanInfo: ILoanInfo;
  userId: number;
  documents: IDocument[];
  errMessage: string;
  fetchAllInfo: boolean;
  allowCreateLoanApplication: boolean;
  companyInfo: ICompanyInfo[];
  references: IReference[];
  netBankingHtml: string;
  bsUploadHtml: string;
  loading: boolean;
  creditReport: any;
  previousFlag: Flags;
  completionDetails: any;
  nextFlag: Flags;
  sourcingCodes: string[];
  sourcingCode: string;
  utmParams: IUTMParams;
  refreshProfile: boolean;
  products: any;
  refreshUserStatus: boolean;
  flagAfterRefreshUserStatus: Flags;
  editMode: boolean;
  param: string;
  config: any;
  search: string;
  profileSaved: boolean;
  mobileOtpVerified: string;
  incompleteInfoDone: boolean;
  bankStatementMandatory: boolean;
  requestLoanErrorMessage: string;
}
const defaultState: IState = {
  userStatus: null,
  userId: null,
  documents: [],
  errMessage: null,
  fetchAllInfo: false,
  allowCreateLoanApplication: false,
  loanInfo: null,
  companyInfo: [],
  references: [],
  ...flagsState,
  netBankingHtml: null,
  bsUploadHtml: null,
  loading: false,
  creditReport: null,
  previousFlag: null,
  completionDetails: null,
  nextFlag: null,
  sourcingCodes: [],
  sourcingCode: null,
  utmParams: null,
  refreshProfile: false,
  products: null,
  refreshUserStatus: true,
  flagAfterRefreshUserStatus: null,
  editMode: false,
  param: null,
  config: null,
  search: null,
  profileSaved: false,
  mobileOtpVerified: null,
  incompleteInfoDone: null,
  bankStatementMandatory: false,
  requestLoanErrorMessage: null,
};

export default function userform(state = defaultState, action) {
  let flags = [];
  let flagsV3 = [];
  let completionDetails = null;
  let loanInfo = null;
  let profile = null;
  let userStatus = null;
  let loanApprovalInfo = null;
  let utmParams = null;
  switch (action.type) {
    case Actions.REQUEST_PROFILE_INFO:
      return {
        ...state,
        loading: true,
        refreshUserStatus: false,
      };
    case `${Actions.REQUEST_PROFILE_INFO}_SUCCESS`:
      userStatus = action.body;
      let bankStatementMandatory = false;
      completionDetails = getCompletionDetails(userStatus.profileStatus,
        state.documents, userStatus.bankStatementsStatus, userStatus);
      flags = [];
      flagsV3 = [];
      flags.push(getLandingFlag(completionDetails ? completionDetails.completePages : []));
      flagsV3.push(getV3LandingFlag(completionDetails ? completionDetails.v3CompletePages : []));
      bankStatementMandatory = action.body.mandatoryCompletionItems.includes("BANK_STATEMENT");
      return {
        ...state,
        userId: action.body.userId,
        userStatus: action.body,
        fetchAllInfo: true,
        loading: false,
        completionDetails,
        flags,
        flagsV3,
        refreshProfile: false,
        flagAfterRefreshUserStatus: null,
        profileSaved: false,
        bankStatementMandatory,
      };
    case Actions.REQUEST_SEARCH_COMPANIES:
      return {
        ...state,
      };
    case `${Actions.REQUEST_SEARCH_COMPANIES}_SUCCESS`:
      return {
        ...state,
        companyInfo: action.body.hits.hit,
      };
    case `${Actions.REQUEST_REFERENCES}_SUCCESS`:
      return {
        ...state,
        references: action.body,
        fetchAllInfo: false,
      };
    case Actions.REQUEST_CREATE_LOAN_APPLICATION:
      return {
        ...state,
        loading: true,
        requestLoanErrorMessage: null,
      };
    case `${Actions.REQUEST_CREATE_LOAN_APPLICATION}_SUCCESS`:
      let loanType;
      if (state.loanInfo.amount >= 15000 && state.loanInfo.amount <= 25000) {
        loanType = "MINI LOAN";
        logBranchEvent("FINAL_MINI_LOAN_APPLIED", {userId, amount: state.loanInfo.amount});
      } else if (state.loanInfo.amount > 25000) {
        loanType = "PERSONAL_LOAN";
        logBranchEvent("FINAL_PERSONAL_LOAN_APPLIED", {userId, amount: state.loanInfo.amount});
      }
      return {
        ...state,
        loading: false,
        refreshUserStatus: true,
        flagAfterRefreshUserStatus: Flags.showFormComplete,
        incompleteInfoDone: true,
        refreshProfile: true,
        requestLoanErrorMessage: null,
      };
    case `${Actions.REQUEST_CREATE_LOAN_APPLICATION}_FAILURE`:
      return {
        ...state,
        requestLoanErrorMessage: action.body.error,
      };
    case `${Actions.REQUEST_REFERENCES}_FAILURE`:
      return {
        ...state,
        fetchAllInfo: false,
      };
    case Actions.SAVE_PROFILE:
      const profileStatus = Object.assign({}, action.body);
      state.userStatus.profileStatus = profileStatus;
      flags = [];
      flagsV3 = [];
      if (state.flags[0] === Flags.showIncompleteInfo) {
        flags.push(Flags.showIncompleteInfo);
        flagsV3.push(Flags.showIncompleteInfo);
      } else if (state.flagAfterRefreshUserStatus) {
        flags.push(state.flagAfterRefreshUserStatus);
        flagsV3.push(state.flagAfterRefreshUserStatus);
      } else if (action.forwardFlag) {
        flags.push(action.forwardFlag);
        flagsV3.push(action.forwardFlag);
      } else {
        completionDetails = getCompletionDetails(profileStatus,
            state.documents, state.userStatus.bankStatementsStatus, state.userStatus);
        flags.push(getLandingFlag(completionDetails ? completionDetails.completePages : []));
        flagsV3.push(getV3LandingFlag(completionDetails ? completionDetails.v3CompletePages : []));
      }
      return {
        ...state,
        loading: false,
        completionDetails,
        flags,
        flagsV3,
        flagAfterRefreshUserStatus: null,
      };
    case `${DocumentActions.REQUEST_DOCUMENTS}_SUCCESS`:
      action.body.map((document) => document.date = new Date(document.date));
      completionDetails = getCompletionDetails(state.userStatus ? state.userStatus.profileStatus : null,
        action.body, state.userStatus ? state.userStatus.bankStatementsStatus : null, state.userStatus);
      flags = [];
      flagsV3 = [];
      flags.push(getLandingFlag(completionDetails ? completionDetails.completePages : []));
      flagsV3.push(getV3LandingFlag(completionDetails ? completionDetails.v3CompletePages : []));
      return {
        ...state,
        documents: action.body,
        completionDetails,
        flags,
        flagsV3,
      };
    case Actions.REQUEST_SAVE_AADHAAR_INFO:
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_SAVE_AADHAAR_INFO}_SUCCESS`:
      state.userStatus.aadhaarStatus.aadhaarNumber = action.payload.service.body.uid;
      return {
        ...state,
        loading: false,
      };
    case Actions.CLEAR_REQUEST_LOAN_ERROR_RESPONSE:
      return {
        ...state,
        requestLoanErrorMessage: null,
      };
    case Actions.REQUEST_SAVE_LOAN_INFO:
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_SAVE_LOAN_INFO}_SUCCESS`:
      loanInfo = action.payload.service.body;
      flags = [];
      flagsV3 = [];
      if (state.flags[0] === Flags.showIncompleteInfo) {
        flags.push(Flags.showIncompleteInfo);
        flagsV3.push(Flags.showIncompleteInfo);
      } else if (!state.editMode) {
        completionDetails = getCompletionDetails(state.userStatus ? state.userStatus.profileStatus : null,
          state.documents, state.userStatus ? state.userStatus.bankStatementsStatus : null, state.userStatus);
        flags.push(getLandingFlag(completionDetails ? completionDetails.completePages : []));
        flagsV3.push(getV3LandingFlag(completionDetails ? completionDetails.v3CompletePages : []));
      } else {
        completionDetails = state.completionDetails;
        flags = state.flags;
      }
      delete loanInfo.facebookToken;
      return {
        ...state,
        loanInfo,
        loading: false,
        completionDetails,
        flags,
        flagsV3,
      };
    case `${Actions.REQUEST_LOAN_INFO}_SUCCESS`:
      loanInfo = action.body;
      completionDetails = getCompletionDetails(state.userStatus ? state.userStatus.profileStatus : null,
        state.documents, state.userStatus ? state.userStatus.bankStatementsStatus : null, state.userStatus);
      flags = [];
      flagsV3 = [];
      flags.push(getLandingFlag(completionDetails ? completionDetails.completePages : []));
      flagsV3.push(getV3LandingFlag(completionDetails ? completionDetails.v3CompletePages : []));
      return {
        ...state,
        loanInfo,
        flags,
        flagsV3,
        completionDetails,
      };
    case Actions.SET_USER_FLAG:
      flags = handleSingleFlagChange(state.flags, action);
      flagsV3 = flags;
      return {
        ...state,
        flags,
        flagsV3,
      };
    case Actions.REMOVE_ALL_FLAGS:
      return {
        ...state,
        flags: [],
      };
    case Actions.REQUEST_FETCH_BS_UPLOAD:
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_FETCH_BS_UPLOAD}_SUCCESS`:
      return {
        ...state,
        bsUploadHtml: action.body,
        loading: false,
      };
    case Actions.REQUEST_FETCH_NET_BANKING:
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_FETCH_NET_BANKING}_SUCCESS`:
      return {
        ...state,
        netBankingHtml: action.body,
        loading: false,
      };
    case Actions.CLEAR_BS_UPLOAD_CONTENT:
      return {
        ...state,
        bsUploadHtml: null,
      };
    case Actions.CLEAR_NET_BANKING_CONTENT:
      return {
        ...state,
        netBankingHtml: null,
      };
    case Actions.CLEAR_BS_UPLOAD_CONTENT:
      return {
        ...state,
        bsUploadHtml: null,
      };
    case Actions.REQUEST_CREDIT_REPORT:
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_CREDIT_REPORT}_SUCCESS`:
      return {
        ...state,
        loading: false,
        creditReport: action.body,
      };
    case DocumentActions.REQUEST_SAVE_DOCUMENT:
      return {
        ...state,
        loading: true,
      };
    case `${DocumentActions.REQUEST_SAVE_DOCUMENT}_SUCCESS`:
      logBranchEvent("DOCUMENT_UPLOADED", {userId, documentType});
      const docTemp = [...state.documents];
      const doc = state.documents.filter((d) => d !== null && d.type === action.payload.extra.docType);
      const docIndex = state.documents.indexOf(doc[0]);
      const docitem = {
        type: action.payload.extra.docType,
        image: action.payload.service.body.content,
        date: new Date(),
      };
      if (docIndex === -1) {
        docTemp.push(docitem);
      } else {
        docTemp[docIndex] = docitem;
      }
      return {
        ...state,
        loading: false,
        documents: docTemp,
      };
    case Actions.SAVE_SOURCING_CODE:
      utmParams = state.utmParams;
      if (action.sourcingCode && action.sourcingCode !== "") {
        if (!utmParams) {
          utmParams = {
            source: null,
            medium: null,
            campaign: null,
          };
        }
        utmParams.source = action.sourcingCode;
      }
      return {
        ...state,
        sourcingCode: action.sourcingCode,
        utmParams,
      };
    case Actions.SAVE_UTM_PARAMS:
      utmParams = state.utmParams;
      if (action.value && validateUtmParams(action.value)) {
        utmParams = action.value;
      }
      return {
        ...state,
        sourcingCode: action.value && action.value.source ? action.value.source.toUpperCase() : null,
        utmParams,
      };
    case Actions.REFRESH_PROFILE:
      return {
        ...state,
        refreshProfile: true,
      };
    case Actions.CHANGE_REFRESH_PROFILE_STATUS:
      return {
          ...state,
        refreshProfile: action.changeTo,
      };
    case Actions.SAVE_PRODUCTS:
      return {
        ...state,
        products: action.value,
      };
    case Actions.SAVE_EDIT_MODE:
      return {
        ...state,
        editMode: action.value,
      };
    case Actions.SAVE_CONFIG:
      return {
        ...state,
        param: action.param,
        config: action.config,
      };
    case Actions.SAVE_SEARCH:
      return {
        ...state,
        search: action.search,
      };
    case Actions.REFRESH_USER_STATUS:
      return {
        ...state,
        refreshUserStatus: action.refresh,
        flagAfterRefreshUserStatus: action.flag,
      };
    case Actions.REQUEST_OTP:
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_OTP}_SUCCESS`:
      return {
        ...state,
        loading: false,
      };
    case `${Actions.REQUEST_OTP}_FAILURE`:
      return {
        ...state,
        loading: false,
      };
    case Actions.REQUEST_VALIDATE_OTP:
      profile = state.userStatus.profileStatus;
      profile.mobile = action.payload.service.body.mobileNumber;
      state.userStatus.profileStatus = profile;
      return {
        ...state,
        loading: true,
      };
    case `${Actions.REQUEST_VALIDATE_OTP}_SUCCESS`:
      return {
        ...state,
        mobileOtpVerified: action.body,
        loading: false,
      };
    case `${Actions.REQUEST_VALIDATE_OTP}_FAILURE`:
      return {
        ...state,
        mobileOtpVerified: action.body,
        loading: false,
      };
    case Actions.SET_INCOMPLETE_INFO_STATUS:
      return {
        ...state,
        incompleteInfoDone: action.status,
      };
    case `${ConsentActions.REQUEST_SAVE_DOCUMENTS_CONSENT}_SUCCESS`:
      loanApprovalInfo = Object.assign({}, state.userStatus.latestApplicationsStatus.loanApprovalInfo);
      loanApprovalInfo.documentsConsentStatus = action.payload.service.body;
      state.userStatus.latestApplicationsStatus.loanApprovalInfo = loanApprovalInfo;
      return {
        ...state,
      };
    case `${ConsentActions.REQUEST_SAVE_DOCUMENTATION_MODE}_SUCCESS`:
      loanApprovalInfo = Object.assign({}, state.userStatus.latestApplicationsStatus.loanApprovalInfo);
      loanApprovalInfo.docAppointment = action.payload.service.body;
      state.userStatus.latestApplicationsStatus.loanApprovalInfo = loanApprovalInfo;
      return {
        ...state,
      };
    case `${InsuranceActions.REQUEST_PROFILE_FOR_INSURANCE}_SUCCESS`:
      return {
          ...state,
        userStatus: action.body,
      };
    case `${InsuranceActions.SAVE_PROFILE_FOR_INSURANCE}`:
      profile = Object.assign({}, action.body);
      state.userStatus.profileStatus = profile;
      return {
        ...state,
      };
    case ProfileAction.CLEAR_PROFILE_INFO:
      return defaultState;
    default:
      return state;
  }
}
